module.exports = __webpack_public_path__ + "media/images/property_photo2-598e7395.jpg";